import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export function useUrlSearch() {
  const location = useLocation();
  const [search, setSearch] = useState(() => new URLSearchParams(location.search).get("q") || "");
  useEffect(() => {
    const v = new URLSearchParams(location.search).get("q");
    setSearch(v || "");
  }, [location.search]);
  return [search, setSearch];
}
